import React, { useState, useEffect, useForm } from "react";
import Cross from "../SmcLife/Images/crosssign.svg";
import Mobile from "../SmcLife/Images/mobile.svg";
import email from "../SmcLife/Images/mail.svg";
import MaskedInput from "react-text-mask";
import Male from "../SmcLife/Images/male-icon2.svg";
import Female from "../SmcLife/Images/female-icon2.svg";
import CustomDatePicker from "../SmcLife/UtilityComponents/CustomDatePicker.jsx";
import "../SmcLife/IndexLife.css";
import { CalculateUserAge, mobilePattern } from "./UtilityComponents/UtilityFunction";
import { FilterData } from "./UtilityComponents/FilterData";
import * as moment from "moment";
import { useFormik } from 'formik';

const EditDetailCard = (props) => {

    const { editDetailType = "lifeIns" } = props;
    const [Error, setError] = useState({});
    const [IsOccupationDisabled, setIsOccupationDisabled] = useState(false)
    const [DOB, setDOB] = useState(moment(props.Data.DoB).toDate());
    const [MaxDate, setMaxDate] = useState(null);
    const [MinDate, setMinDate] = useState(null);
    const [Gender, setGender] = useState(props.Data.Gender === "M" ? "M" : "F");
    const [Detail, setDetail] = useState(
        props.Data.IsSmoker === false ? "N" : "Y"
    );
    const [formData, setFormData] = useState({
        Occupation: props.Data.Occupation,
        Education: props.Data.Education,
    });
    const [MobileNo, setMobileNo] = useState(props.Data.MobileNo);
    const [Email, setEmail] = useState(props.Data.Email ? props.Data.Email : props.Data.EmailID);
    const [closepop, setclosepop] = useState(true);
    const [showBtn, setShowBtn] = useState(true);
    const [IsFromHouseWifeComponent, setIsFromHouseWifeComponent] = useState(false);
    const houseWifeTermRoute = props.allTermLifePath;

    const initialValues = {
        DOB: "",
        Gender: "",
        MobileNo: "",
        Email: "",
        Occupation: "",
        Education: "",
        IsSmoker: ""
    }

    const validate = () => {
        let error = {};
        if (values.DOB === "" || values.DOB === "Date OF Birth") {
            error["DOB"] = "Select Date Of Birth";
        } if (getAge(values.DOB) > 65) {
            error["DOB"] = "Age should be less than or equal to 65 years";
        }
        if (values.MobileNo === "") {
            error["MobileNo"] = "Please enter mobile number";
        }
        else if (values.MobileNo.length !== 10) {
            error["MobileNo"] = "Please enter valid mobile number";
        }
        else if (values.MobileNo === "9999999999" || values.MobileNo === "8888888888" || values.MobileNo === "7777777777" || values.MobileNo === "6666666666") {
            error["MobileNo"] = "Please enter valid mobile number"
        }
        else if (mobilePattern.test(values.MobileNo)) {
            error["MobileNo"] = "First 6 digits cannot be all the same"
        }
        if (values.Email === "") {
            error["Email"] = "Please enter email";
        } else if (!validateEmail(values.Email)) {
            error["Email"] = "Please enter valid email";
        } else if (values.Email.includes("..")) {
            error["Email"] = "Please enter valid email";
        } else if (values.Email.slice(0, 1) === "." || values.Email.slice(0, 1) === "-") {
            error["Email"] = "Please enter valid email";
        }
        if ((parseInt(props.Data.CoverTillAge) - CalculateUserAge(values.DOB)) <= 5) {
            return alert("Age cannot be less than cover till age and the gap between cover till age and Age should be greater or equal to 5");
        }

        if (values.Education === "") {
            error["Education"] = "Please select education";
        }

        if (!IsFromHouseWifeComponent && values.Occupation === "") {
            error["Occupation"] = "Please select occupation";

        }
        return error;
    }

    const { values, setValues, setFieldValue, setFieldTouched, errors, handleChange, handleBlur, touched, handleSubmit } = useFormik({
        initialValues,
        validate,
        enableReinitialize: true,
        onSubmit: (values) => {
            submitForm(values)
        }
    })


    useEffect(() => {
        setValues({
            ...values,
            DOB: moment(props.Data.DoB).toDate(),
            Gender: props.Data.Gender === "M" ? "M" : "F",
            MobileNo: props.Data.MobileNo,
            Email: props.Data.Email ? props.Data.Email : props.Data.EmailID,
            Occupation: props.Data.Occupation,
            Education: props.Data.Education,
            IsSmoker: props.Data.IsSmoker === false ? "N" : "Y"
        });
    }, []);

    /*const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
*/
    useEffect(() => {
        if (houseWifeTermRoute !== "housewife-term") {
            setIsOccupationDisabled(true)
        }
        else {
            setIsOccupationDisabled(false);
        }
        setIsFromHouseWifeComponent(houseWifeTermRoute);
    }, [])

    useEffect(() => {
        let checkSmoker = values.IsSmoker === "N" ? false : true;
        if (
            props.Data.Gender !== values.Gender ||
            !moment(props.Data.DoB).isSame(moment(values.DOB)) ||
            props.Data.IsSmoker !== checkSmoker ||
            props.Data.MobileNo !== values.MobileNo ||
            props.Data.EmailID !== values.Email ||
            props.Data.Occupation !== values.Occupation ||
            props.Data.Education !== values.Education
        ) {
            setShowBtn(false);
        } else {
            setShowBtn(true);
        }


    }, [values.Gender, values.DOB, values.IsSmoker, values.MobileNo, values.Email, values.Occupation, values.Education]);

    useEffect(() => {
        const minDate = moment().subtract(66, 'years').add(1, 'day').startOf('day');
        setMinDate(minDate.toDate());
        const maxDate = moment().subtract(18, 'years').endOf('day');
        setMaxDate(maxDate.toDate());
    }, [])

    //update the covertill age on DOB set cover till age (DOB+15)
    useEffect(() => {
        let age = getAge(values.DOB)
        if (values.DOB && age <= 85) {
            props.UpdateCoverTillAgeOnDOB(age + 15);
        }
    }, [values.DOB]);

    useEffect(() => {
        if (values.Gender === "M" && values.Occupation === "82") {
            setFieldValue('Occupation', '');
        }
    }, [values.Gender]);

    const IsLifeclose = () => {
        setclosepop(false);
    };


    const validateEmail = (email) => {
        var re =
            /^(([^<>()\[\]\\.,;#:`~\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

 
    const submitForm = (values) => {
        let Request = {
            Gender: values.Gender,
            DOB: values.DOB,
            MobileNo: values.MobileNo,
            Detail: values.IsSmoker,
            Email: values.Email,
            Occupation: values.Occupation,
            Education: values.Education,

        };
        setclosepop(false);
        props.UpdateResult(Request);
    }

    const getAge = (dob) => {
        let today = new Date();
        let birthDate = new Date(dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        let month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };


    return (
        <>
            <div className="SmcEditDetailCard">
                <div className="space">
                    <div className="container">
                        {closepop && (
                            <div className="EditDetailShadow">
                                <div className="DetailBoxCard">
                                    <form action="">
                                        <div className="EditTop">
                                            <div>
                                                <p className="mb-0">
                                                    <b>Edit Details</b>
                                                </p>
                                            </div>
                                            <div className="CrossSign mt-0 px-0" onClick={() => IsLifeclose()}>
                                                <img src={Cross} alt="editdetail" />
                                            </div>
                                        </div>
                                        <hr />
                                        <div>
                                            {editDetailType !== "womenLife" && <div className="IndexLife-cards edit_gender">
                                                <label><b>Gender</b></label>
                                                <label>
                                                    <input type="radio" value="M" name="Gender" checked={values.Gender === "M"}
                                                        onChange={handleChange} />
                                                    <img src={Male} className="IndexMainIpict" alt="Male" />
                                                    Male
                                                </label>
                                                <label>
                                                    <input type="radio" value="F" name="Gender" checked={values.Gender === "F"}
                                                        onChange={handleChange} />
                                                    <img src={Female} className="IndexMainIpict " alt="Female" />
                                                    Female
                                                </label>
                                            </div>}
                                            <div className="user-input-wrp my-4">
                                                <span className="fixed_label">Date of Birth</span>
                                                <CustomDatePicker
                                                    setDOB={(date) => { setFieldValue('DOB', date); setFieldTouched('DOB', true); }}
                                                    minDate={MinDate}
                                                    maxDate={MaxDate}
                                                    RegDate={values.DOB}

                                                />
                                                <small className="UserAge"><b>{getAge(values.DOB)} years</b></small>
                                            </div>
                                            {errors.DOB && touched.DOB && <span className="errors-msg">{errors["DOB"]}</span>}

                                        </div>
                                        <div>
                                            <div className="QueryDetail-cards">
                                                <p className="mb-1">
                                                    <strong>Do you smoke or chew tobacco?</strong>
                                                </p>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        value="N"
                                                        name="IsSmoker"
                                                        checked={values.IsSmoker === "N"}
                                                        onChange={handleChange}
                                                    />
                                                    No
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        value="Y"
                                                        name="IsSmoker"
                                                        checked={values.IsSmoker === "Y"}
                                                        onChange={handleChange}
                                                    />
                                                    Yes
                                                </label>
                                                <p className="lifecheck">
                                                    Choose 'Yes' if you have smoked or chewed tobacco in
                                                    last 1 year
                                                </p>
                                            </div>

                                            <div className="user-input-wrp" id="mobileno">
                                                <MaskedInput
                                                    className="inputText"
                                                    mask={[
                                                        /[6-9]/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                    ]}
                                                    guide={false}
                                                    required
                                                    showMask={false}
                                                    name="MobileNo"
                                                    value={values.MobileNo}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.MobileNo && touched.MobileNo && <span className="errors-msg">{errors["MobileNo"]}</span>}
                                                <span className="floating-label">Mobile Number</span>
                                                <img src={Mobile} className="cellphone" alt="Mobile" />
                                            </div>
                                            <div className="user-input-wrp" id="Emailid">
                                                <input
                                                    type="text"
                                                    className="inputText emailInput pe-4"
                                                    required
                                                    name="Email"
                                                    value={values.Email}
                                                    onKeyDown={(e) => {
                                                        // Prevent typing multiple consecutive spaces
                                                        const { value, selectionStart } = e.target;
                                                        if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.Email && touched.Email && <span className="errors-msg">{errors["Email"]}</span>}
                                                <span className="floating-label">Email Address</span>
                                                <img src={email} className="mail" alt="Email" />
                                            </div>
                                            <div className="user-input-wrp">
                                                <span className="DropDown_label">Select Your Education</span>
                                                <FilterData
                                                    ArrayList={props.EducationList ?? []}
                                                    FilterKey={"CODE"}
                                                    onSelect={(data) => { setFieldValue('Education', data.CODE); setFieldTouched('Education', data.CODE); }}
                                                    DefaultTitle={values.Education ? props.EducationList.find(option => option.CODE === values.Education)?.Name : "Education"}
                                                    ListNameKey={"Name"}
                                                    className="filter_dropdwon"
                                                />
                                            </div>

                                            <div className="user-input-wrp">
                                                {/*<span className={`DropDown_label ${IsFromHouseWifeComponent ? 'DropDown_label_disabled' : ''}`}>Select Your Occupation</span>
                                                {!IsFromHouseWifeComponent &&
                                                    <FilterData
                                                        ArrayList={props.OccupationList ?? []}
                                                        FilterKey={"CODE"}
                                                        onSelect={(data) => {
                                                            setFormData((prev) => ({ ...prev, Occupation: data.CODE }));
                                                        }}
                                                        DefaultTitle={formData.Occupation ? props.OccupationList.find(option => option.CODE === formData.Occupation)?.Name : "Occupation"}
                                                        ListNameKey={"Name"}
                                                        className="filter_dropdwon"
                                                    />
                                                }*/}
                                                {IsOccupationDisabled &&
                                                    <>
                                                    <span className={`DropDown_label ${!IsOccupationDisabled ? 'DropDown_label_disabled' : ''}`}>Select Your Occupation</span>
                                                
                                                 <FilterData
                                                        ArrayList={values.Gender === "M" ? props?.OccupationList.filter(item => item.id !== '82') : props?.OccupationList}
                                                    FilterKey={"id"}
                                                    onSelect={(data) => {
                                                        setFieldValue('Occupation', data.id);
                                                        setFieldTouched('Occupation', true);
                                                    }}
                                                    DefaultTitle={values.Occupation ? props.OccupationList.find(option => option.id == values.Occupation)?.occupation : "Occupation"}
                                                    ListNameKey={"occupation"}
                                                    className="filter_dropdwon"
                                                    /></>}
                                            </div>
                                            <button
                                                type="button"
                                                className="FormGetTouch d-block w-100"
                                                disabled={showBtn}
                                                onClick={handleSubmit}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
export default EditDetailCard;
